import React, { useEffect, useState } from 'react';
import { Button, Modal } from 'react-bootstrap';
import Loader from '../../../Components/Loader/Loader';
import Error from '../../../Components/Error/Error';
import { useCreateFinancialYearMutation, useDeleteFinancialYearMutation, useDetailsByFinancialYearQuery, useFinancialYearsQuery, useUpdateFinancialYearMutation } from '../../../Store/Apis/toolsApi';
import toast from 'react-hot-toast';
import formatDate from '../../../Hooks/formatDate';

const FinancialYears = () => {
  const [addModalShow, setAddModalShow] = useState(false);
  const [searchText, setSearchText] = useState('');

  // Fetch Financial Years
  const financialYearApi = useFinancialYearsQuery({
    keyYear: searchText
  });

  

  
  

  // ADD FINANCIAL YEAR
  const [createFinancialYear, createYearResponse] = useCreateFinancialYearMutation();
  const handleAddYearSubmit = (formData) => {
    createFinancialYear({
      year: formData.year,
      startingDate: formData.startDate,
      endingDate: formData.endDate
    }).then((res) => {
      toast.success(res?.data?.message, { duration: 7000 });
      setAddModalShow(false)
    });
  };

  // UPDATE FINANCIAL YEAR
  const [selectedEditYear, setSelectedEditYear] = useState(null);
  const detailsByFinancialYear = useDetailsByFinancialYearQuery(selectedEditYear, {skip: !selectedEditYear});
  const [updateFinancialYear, updateYearResponse] = useUpdateFinancialYearMutation();
  const handleEditYearSubmit = (data) => {
    updateFinancialYear({
      id: data.id,
      year: selectedEditYear,
      startingDate: data.startDate,
      endingDate: data.endDate,
    }).then((res) => setSelectedEditYear(null));
  };

  // Financial Year Form Component
  const FinancialYearForm = ({ onSubmit, initialData }) => {
    const [formData, setFormData] = useState({
      year: '',
      startDate: '',
      endDate: '',
    });

    useEffect(()=>{
      if(initialData){
        setFormData({
          id: initialData.id || '',
          year: initialData.year || '',
          startDate: initialData.startDate ? initialData.startDate?.split("T")[0] : '',
          endDate: initialData.endDate ? initialData.endDate?.split("T")[0] : '',
        })
      }      
    }, [initialData])

    const handleChange = (e) => {
      const { name, value } = e.target;
      setFormData({ ...formData, [name]: value });
    };

    const handleSubmit = (e) => {
      e.preventDefault();
      if (formData.year && formData.startDate && formData.endDate) {
        onSubmit(formData);
      }
    };

    return (
      <form onSubmit={handleSubmit}>
        <div className="mb-3">
          <label>Year</label>
          <input
            type="number"
            name="year"
            value={formData.year}
            onChange={handleChange}
            className="form-control"
            required
          />
        </div>
        <div className="mb-3">
          <label>Start Date</label>
          <input
            type="date"
            name="startDate"
            value={formData.startDate}
            onChange={handleChange}
            className="form-control"
            required
          />
        </div>
        <div className="mb-3">
          <label>End Date</label>
          <input
            type="date"
            name="endDate"
            value={formData.endDate}
            onChange={handleChange}
            className="form-control"
            required
          />
        </div>
        <Button type="submit" className="btn btn-primary">
          Submit
        </Button>
      </form>
    );
  };
  

  const handleSearch = (value) => {
    setSearchText(value);
  };


  // DELETE
  const [selectedRecord, setSelectedRecord] = useState(null);
  const [deleteFinancialYear] = useDeleteFinancialYearMutation()
  const handleDelete = () => {
    deleteFinancialYear(selectedRecord).then((res)=>{
      setSelectedRecord(null)
    })
  }

  return (
    <div>
      <div className="row align-items-center justify-content-between mb-3">
        <div className="col">
          <h5 className="fw-500 text-white mb-0">Financial Years</h5>
        </div>
        <div className="col-auto">
          <button onClick={() => setAddModalShow(true)} className="btn btn-icon btn-3 btn-white text-primary mb-0">
            <i className="fa fa-plus me-2"></i> Add New Financial Year
          </button>
        </div>
      </div>

      <div className="card">
        <div className="card-header p-4">
          <div className="row">
            <div className="col-md-12">
              <input
                type="text"
                className="form-control"
                placeholder="Search by Year"
                onChange={(event)=>handleSearch(event.target.value)}
              />
            </div>
          </div>
        </div>
        <div className="card-body p-0">
          {financialYearApi.isError && <Error />}
          {financialYearApi.isLoading && <Loader height="500px" />}
          {financialYearApi.isSuccess && (
            <div className="table-responsive">
              <table className="table align-items-center mb-0">
                <thead className="bg-light">
                  <tr>
                    <th className='text-uppercase text-secondary text-xs opacity-7'>Year</th>
                    <th className='text-uppercase text-secondary text-xs opacity-7'>Start Date</th>
                    <th className='text-uppercase text-secondary text-xs opacity-7'>End Date</th>
                    <th className='text-uppercase text-secondary text-xs opacity-7'>Actions</th>
                  </tr>
                </thead>
                <tbody>
                  {financialYearApi.data.data.map((elem, i) => (
                    <tr key={i}>
                      <td className='px-4 text-sm'>{elem.year}</td>
                      <td className='px-4 text-sm'>{formatDate(elem.startingDate)}</td>
                      <td className='px-4 text-sm'>
                        {formatDate(elem.endingDate)}
                      </td>
                      <td>
                        <button
                          className="btn badge badge-warning text-xs mx-2 mb-0"
                          onClick={() => setSelectedEditYear(elem.year)}
                        >
                          Edit
                        </button>
                        <button 
                          className="btn badge badge-xs badge-danger fw-600 text-xs mb-0 mx-2"
                          onClick={()=>setSelectedRecord(elem.id)}  
                        >Delete</button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}
        </div>
      </div>

      {/* Add Financial Year Modal */}
      <Modal show={addModalShow} onHide={() => setAddModalShow(false)} size="lg" centered>
        <Modal.Header closeButton>
          <Modal.Title>Add Financial Year</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          
          <FinancialYearForm
            onSubmit={handleAddYearSubmit}
          />
          
        </Modal.Body>
      </Modal>

      {/* Edit Financial Year Modal */}
      {selectedEditYear && (
        <Modal show={selectedEditYear} onHide={() => setSelectedEditYear(null)} size="lg" centered>
          <Modal.Header closeButton>
            <Modal.Title>Edit Financial Year</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {
              detailsByFinancialYear.isError && <Error />
            }
            {
              detailsByFinancialYear.isLoading && <Loader height={300} />
            }
            {
              detailsByFinancialYear.isSuccess && (
                <FinancialYearForm
                  initialData={{
                    id: detailsByFinancialYear.data.data[0].id || '',
                    year: detailsByFinancialYear.data.data[0].year || '',
                    startDate: detailsByFinancialYear.data.data[0].startingDate || '',
                    endDate: detailsByFinancialYear.data.data[0].endingDate || '',
                  }} 
                  onSubmit={handleEditYearSubmit}
                />
              )
            }
            
          </Modal.Body>
        </Modal>
      )}

      {/* DELETE MODAL */}
      <Modal  
        show={selectedRecord} 
        onHide={() => setSelectedRecord(null)} 
        size="sm" 
        centered
        >
        <Modal.Body className='text-center p-4'>
            <h5>Are you sure you want to delete this year?</h5>
            <p className='text-sm mb-4'>
              This action will permanently delete this year and may impact ongoing processes. Please confirm to proceed.
            </p>
            <div className="buttons d-flex gap-3 justify-content-center">
                <button className='btn btn-danger bg-danger btn-sm mb-0' onClick={()=>(setSelectedRecord(null))}>Cancel</button>
                <button className='btn btn-primary btn-sm mb-0' onClick={handleDelete}>Confirm</button>
            </div>
        </Modal.Body>
      </Modal>
    </div>
  );
};

export default FinancialYears;
